import { useContext } from "react"
import { IntegracaoWhatsappContext } from "./IntegracaoWhatsappContext"

export function useIntegracaoWhatsappContext() {
    return useContext(IntegracaoWhatsappContext)
}
